import { Button, Input } from "reactstrap";

const TypeQuickNote = ({ text, setText, goBack, goForward }) => {
  return (
    <div className="mx-4 pb-3 mt-3">
      <div className="mb-2 font-weight-500" style={{ fontSize: 14 }}>
        Type Your Message
      </div>
      <Input
        placeholder="Enter text"
        type="textarea"
        rows={8}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <div className="d-flex justify-content-between mt-4">
        <Button size="sm" outline onClick={goBack}>
          Back to Recording
        </Button>
        <Button size="sm" color="primary" disabled={!text} onClick={goForward}>
          Preview
        </Button>
      </div>
    </div>
  );
};

export default TypeQuickNote;
